// extracted by mini-css-extract-plugin
export default {"dividerBlock":"DividerBlock_dividerBlock__7Otur","illustration":"DividerBlock_illustration__wuBVx"};